(function ($) {
  var sign_up_section = $(".sign-up-tab");
  if (sign_up_section) {
    $(".sign-up-tab .overlay-search .ais-SearchBox-input").focus(function () {
      $(this).css("border-color", "#98002e");
    });
    $(".sign-up-tab .overlay-search .ais-SearchBox-input").blur(function () {
      $(this).css("border-color", "");
    });
    $(".sign-up-tab .overlay-search .ais-SearchBox-input").keypress(
      function () {
        if ($(this).value !== "") {
          $(".ais-SearchBox-reset").css("display", "block");
          $(".aa-dropdown-menu").css({
            display: "block",
            position: "relative !important",
          });
        } else {
          $(".ais-SearchBox-reset").css("display", "none");
          $(".aa-dropdown-menu").css("display", "none");
        }
      }
    );
    $(".ais-SearchBox-reset").click(function () {
      $(".sign-up-tab .overlay-search .ais-SearchBox-input").value = "";
      $(".aa-dropdown-menu").css("display", "none");
    });

    $(".sign-up-tab .input-wrap input")
      .focus(function () {
        $(this).parent(".input-wrap").addClass("placeholder");
      })
      .blur(function () {
        $(this).parent(".input-wrap").removeClass("placeholder");
      });

    $(".sign-up-tab .input-wrap").on("blur", "input", function () {
      if ($(this).val()) {
        $(this).parent().addClass("used");
      } else {
        $(this).parent().removeClass("used");
      }
    });

    $(document).on("click", ".sign-up-tab .col-three-card.card-without-link", function (e) {
      e.stopPropagation();
      $(this).find(".check-box-wrap label").trigger("click");
    });
    $(document).on(
      "click",
      ".sign-up-tab .col-three-card.card-without-link .check-box-wrap label",
      function (e) {
        e.stopPropagation();
      }
    );

    $(document).on("click", ".fellow-topics .fellow-wrapper .fellow-card", function (e) {
      e.stopPropagation();
      $(this).toggleClass("card-active");
      $(this).find(".check-box-wrap label").trigger("click");
    });
    $(document).on(
      "click",
      ".fellow-topics .fellow-wrapper .fellow-card label",
      function (e) {
        e.stopPropagation();
      }
    );

  }

  $(".sign-up-tab .form-wrap .input-wrap .eye-wrap").on("click", function () {
    var x = $(this).closest(".input-wrap").find("input").attr("type");

    if (x.toString() === "password") {
      x = "text";
      $(this).closest(".input-wrap").find("input").attr("type", x);
      $(this).addClass("eye-active");
    } else {
      x = "password";
      $(this).closest(".input-wrap").find("input").attr("type", x);
      $(this).removeClass("eye-active");
    }
  });

  function matchCard() {
    $(".sign-up-tab .col-three-card").matchHeight();
    // $(".fellow-topics .fellow-card").matchHeight();
  }
  $(window).on("load", function () {
    matchCard();
  });
  $(window).on("resize", function () {
    matchCard();
  });
})(jQuery);
